import config from '../../config';
import { seoContent } from "../../constants/SEOConstant";
import { GuidesPage } from './GuidesPage';
import { LinksFromStreamtoStreamForSync, LinksFromStreamtoStreamForTransfer, TransferLinksDataFromStreamtoStream } from './LinksFromStreamtoStream';

export default function YoutubeGuide() {
    return (
        <GuidesPage
            seoData={seoContent.youtube}
            sections={
                <div className="bg-white dark:bg-zinc-950 text-gray-900 dark:text-white">
                    <div className="max-w-screen-xl pt-20 px-4 py-8 mx-auto lg:py-24 lg:px-6 lg:pt-28">
                        <section className="bg-white dark:bg-zinc-950">
                            <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
                                <h1 className="mb-4 text-4xl font-extrabold tracking-tight text-gray-900 dark:text-white lg:text-5xl">
                                    Transfer and Sync YouTube Playlists
                                </h1>
                                <p className="mb-8 font-light text-gray-500 sm:text-xl dark:text-gray-400">
                                    Your hub for music videos, official tracks, and community playlists on YouTube—watch and listen on any device.
                                </p>
                            </div>
                        </section>

                        <section className="bg-white dark:bg-zinc-950 py-12">
                            <div className="max-w-screen-xl px-4 mx-auto lg:px-6">
                                <div className="max-w-screen-md mx-auto text-center">
                                    <p className="text-lg leading-relaxed text-gray-600 dark:text-gray-300 mb-4">
                                        YouTube brings together music videos, live performances, and user-made playlists in one place.
                                        Whether you are building a channel library or saving playlists for offline listening, YouTube keeps your collection accessible on web, TV, and mobile.
                                    </p>
                                    <p className="text-lg text-gray-600 dark:text-gray-300">
                                        Open YouTube here:{' '}
                                        <a
                                            href="https://www.youtube.com"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-purple-600 dark:text-purple-400 underline font-medium hover:text-purple-700 dark:hover:text-purple-300"
                                        >
                                            YouTube
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </section>

                        <section className="bg-gray-50 dark:bg-zinc-900">
                            <div className="max-w-screen-xl px-4 py-16 mx-auto lg:py-24 lg:px-6">
                                <div className="max-w-screen-md mx-auto text-center mb-12">
                                    <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
                                        Bring playlists to YouTube—or move them elsewhere
                                    </h2>
                                    <p className="text-gray-500 dark:text-gray-400">
                                        Whether you are consolidating on YouTube or switching to another service,
                                        <span className="font-semibold text-purple-600 dark:text-purple-400"> Music Porter </span>
                                        helps you migrate playlists and keep them in sync across Spotify, Apple Music, YouTube Music, and YouTube.
                                    </p>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                                    <div className="text-center">
                                        <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-6 text-white font-bold text-xl">1</div>
                                        <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Connect accounts</h3>
                                        <p className="text-gray-500 dark:text-gray-400">
                                            Link your YouTube account and other music services in Music Porter.
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-6 text-white font-bold text-xl">2</div>
                                        <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Select content</h3>
                                        <p className="text-gray-500 dark:text-gray-400">
                                            Choose playlists and libraries to copy between services.
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-6 text-white font-bold text-xl">3</div>
                                        <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Transfer & sync</h3>
                                        <p className="text-gray-500 dark:text-gray-400">
                                            Run a transfer, then create sync from history to keep paired playlists updated.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="bg-gray-50 dark:bg-zinc-900 py-12">
                            <div className="max-w-screen-xl px-4 mx-auto lg:px-6">
                                <div className="max-w-screen-md mx-auto text-center mb-12">
                                    <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
                                        Transfer your music
                                    </h2>
                                    <p className="text-gray-500 dark:text-gray-400">
                                        Move libraries between YouTube and other streaming services.
                                    </p>
                                </div>

                                <div className="mb-8">
                                    <h3 className="text-2xl font-bold mb-6 text-center">Transfer from other services to YouTube</h3>
                                    <LinksFromStreamtoStreamForTransfer links={TransferLinksDataFromStreamtoStream["youtube"].to} />
                                </div>

                                <div className="mb-8">
                                    <h3 className="text-2xl font-bold mb-6 text-center">Transfer from YouTube to other services</h3>
                                    <LinksFromStreamtoStreamForTransfer links={TransferLinksDataFromStreamtoStream["youtube"].from} />
                                </div>
                            </div>
                        </section>

                        <section className="bg-gray-50 dark:bg-zinc-800">
                            <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-16 lg:px-6">
                                <div className="max-w-screen-sm mx-auto text-center">
                                    <h2 className="mb-4 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 dark:text-white">
                                        Ready to transfer your YouTube playlists?
                                    </h2>
                                    <p className="mb-6 font-light text-gray-500 dark:text-gray-400 md:text-lg">
                                        Start your first transfer for free today.
                                    </p>
                                    <div className="space-y-4 sm:flex sm:space-y-0 sm:space-x-4 justify-center">
                                        <a
                                            href={config.signupPath}
                                            className="inline-flex items-center justify-center w-full px-5 py-3 text-sm font-medium text-center text-white bg-purple-700 border border-transparent rounded-lg sm:w-auto hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800"
                                        >
                                            Sign up for free
                                        </a>
                                        <a
                                            href="/sync-playlists"
                                            className="text-purple-700 bg-white border border-purple-700 hover:bg-purple-50 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-8 py-3 dark:text-purple-400 dark:border-purple-400 dark:hover:bg-purple-900/20 focus:outline-none dark:focus:ring-purple-800 transition-colors duration-200"
                                        >
                                            Learn About Sync
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="bg-white dark:bg-zinc-950 py-12">
                            <div className="max-w-screen-xl px-4 mx-auto lg:px-6">
                                <div className="max-w-screen-md mx-auto text-center mb-12">
                                    <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
                                        Keep your playlists in sync
                                    </h2>
                                    <p className="text-gray-500 dark:text-gray-400">
                                        After a transfer, sync keeps paired playlists aligned across services.
                                    </p>
                                </div>

                                <div className="mb-8">
                                    <h3 className="text-2xl font-bold mb-6 text-center">Sync playlists from YouTube to other services</h3>
                                    <LinksFromStreamtoStreamForSync links={TransferLinksDataFromStreamtoStream["youtube"].from} />
                                </div>

                                <div className="mb-8">
                                    <h3 className="text-2xl font-bold mb-6 text-center">Sync playlists from other services to YouTube</h3>
                                    <LinksFromStreamtoStreamForSync links={TransferLinksDataFromStreamtoStream["youtube"].to} />
                                </div>
                            </div>
                        </section>
                    </div>

                    <section className="bg-gray-50 dark:bg-zinc-800">
                        <div className="max-w-screen-xl px-4 py-16 mx-auto lg:py-24 lg:px-6">
                            <div className="max-w-screen-md mx-auto text-center">
                                <h2 className="mb-6 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 dark:text-white lg:text-4xl">
                                    Ready to keep your YouTube playlists in sync?
                                </h2>
                                <p className="mb-8 font-light text-gray-500 dark:text-gray-400 md:text-lg">
                                    Connect services once and let Music Porter handle ongoing updates.
                                </p>

                                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                                    <a
                                        href={config.signupPath}
                                        className="text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-8 py-3 dark:bg-purple-600 dark:hover:bg-purple-700 focus:outline-none dark:focus:ring-purple-800 transition-colors duration-200"
                                    >
                                        Start Now
                                    </a>
                                    <a
                                        href="/transfer-playlists-and-songs"
                                        className="text-purple-700 bg-white border border-purple-700 hover:bg-purple-50 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-8 py-3 dark:text-purple-400 dark:border-purple-400 dark:hover:bg-purple-900/20 focus:outline-none dark:focus:ring-purple-800 transition-colors duration-200"
                                    >
                                        Learn About Transfer
                                    </a>
                                </div>

                                <div className="mt-8 text-sm text-gray-500 dark:text-gray-400">
                                    <p>✓ No credit card required • ✓ Free forever transfer • ✓ Lifetime plan available</p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            }
        />
    );
}
